import React, {ReactNode, useEffect, useState} from 'react'
import makeAnimated from 'react-select/animated';
import Select, {MultiValue} from "react-select";

export interface ISelectOption {
    value: string
    text: string
}

export interface IMultiSelectOption {
    label: string|number
    value: string|number
}

interface ISelectInput {
    placeholder: string
    changeHandler: (data: (string|number)[]) => any,
    values: (string|number)[],
    disabled?: boolean,
    label?: string | ReactNode
    name: string,
    customClassName?: string,
    customLabelClassName?: string,
    customLabel?: React.ComponentType
    validationError?: boolean,
    validationErrorDescription?: string,
    require?: boolean,
    id?: string,
    options: ISelectOption[],
    isMultiple?: boolean
}

const FormSelect: React.FC<ISelectInput> = (
    {
        placeholder,
        changeHandler,
        disabled = false,
        label,
        name,
        customClassName,
        customLabelClassName,
        customLabel,
        validationError,
        validationErrorDescription,
        values,
        require = true,
        id,
        options,
    }
) => {

    const [customOptions, setCustomOptions] = useState<IMultiSelectOption[]>([])
    const [selectedValues, setSelectedValues] = useState<IMultiSelectOption[]>([])

    useEffect(() => {
        //@ts-ignore
        setCustomOptions([
            ...options.map(o => {
                return {
                    label: o.text,
                    value: o.value,
                }
            })
        ])
        console.log("multiSelectOptions", id, options)
    }, [options])

    useEffect(() => {
        if (values && customOptions && customOptions.length > 0) {
            values.map(v => {
                if (!customOptions.find(o => o.value === v)) {
                    setCustomOptions([{label: v, value: v}, ...customOptions])
                }
            })
        }
        console.log("multiSelectOptionsByValues", id, values, customOptions)
    }, [customOptions])

    useEffect(() => {
        //@ts-ignore
        setSelectedValues(!values ? [] : [
        ...values.map(v => {
                const o = options.find(o => o.value === v) || {text: v, value: v}
                return {
                    label: o.text,
                    value: o.value,
                }
            })
        ])
        console.log("khgkjdshkgjd", id, values, customOptions)
    }, [values])

    const selectHandler = (selectedList: MultiValue<IMultiSelectOption>) => {
        console.log('multiselected', selectedList.map(v => v.value))
        changeHandler(selectedList.map(v => v.value))
    }

    const animatedComponents = makeAnimated();

    return (
        <>
            {customLabel ?
                (
                    <div className="flex">
                        {/*@ts-ignore*/}
                        {customLabel}
                    </div>
                )
                :
                label &&
                (
                    <>
                        <label
                            className={`block text-gray-600 text-left font-medium mb-1 ${customLabelClassName ? customLabelClassName : ""}`}
                            htmlFor={name}
                        >
                            {label}
                            {require && <span className="text-red-500 px-1">*</span>}
                        </label>
                    </>
                )
            }
            <Select
                value={selectedValues}
                name="id"
                components={animatedComponents}
                options={customOptions}
                isMulti
                onChange={selectHandler}
                closeMenuOnSelect={false}
                placeholder={""}
            />
            {
                validationErrorDescription && (
                    <div className="text-xs text-left text-red-500">
                        {validationErrorDescription}
                    </div>
                )
            }
        </>
    )
}

export default FormSelect